import React from 'react';
import { View, StyleSheet, Text, ScrollView } from 'react-native';
import { Card, Divider, Button } from '@rneui/themed';
import { useTranslation } from 'react-i18next';

import { ActivityModal } from '../modal/Modal';
import { branchComponent } from './infoMap';
import DialogStyle from 'styles/Dialog';
import { type ColumnInfoType } from 'types/ColumnInfo';

const styles = StyleSheet.create(DialogStyle.dialog);

interface Props {
  data: ColumnInfoType;
  submitFunc: (
    values: ColumnInfoType,
    callback: (data: any) => void
  ) => void | Promise<void>;
  handleFinalModal: () => void;
  title: string;
  message: string;
}

const DecisionDialog: React.FC<Props> = ({
  data,
  submitFunc,
  handleFinalModal,
  title,
  message,
}) => {
  const { t } = useTranslation();

  const [modalState, setModalState] = React.useState({
    isVisible: false,
    loading: false,
  });

  const onSubmit = (values: ColumnInfoType): void => {
    setModalState({
      isVisible: true,
      loading: true,
    });

    void submitFunc(values, afterSubmit);
  };

  const afterSubmit = (data: object): void => {
    console.log(data);
    setModalState({
      isVisible: true,
      loading: false,
    });
  };

  return (
    <View style={styles.container}>
      <ActivityModal
        modalState={modalState}
        closeFunc={handleFinalModal}
        message={message}
      />
      <Card containerStyle={styles.cardContainer}>
        <Card.Title>
          <Text>{title}</Text>
        </Card.Title>
        <Card.Divider />
        <View style={styles.horizontal}>
          {data !== null ? (
            <>
              <ScrollView>
                {Object.keys(data).map((key, index) => {
                  if (data[key].type !== 'hidden') {
                    return (
                      <React.Fragment key={index}>
                        <View style={styles.horizontalContainer}>
                          <Text style={styles.horizontalText}>
                            {data[key].name}:{' '}
                          </Text>
                          <>{branchComponent(key, data[key])}</>
                        </View>
                        <Divider inset={true} insetType="right" />
                      </React.Fragment>
                    );
                  }
                })}
              </ScrollView>
              <Button
                title={t('select')}
                onPress={() => {
                  onSubmit(data);
                }}
              />
            </>
          ) : null}
        </View>
      </Card>
    </View>
  );
};

export default DecisionDialog;
